const OurStore = () => {
    return (
        <>
        <div className="tf-page-title style-2">
            <div className="container-full">
                <div className="heading text-center">Our Store</div>
            </div>
        </div>
        <section className="flat-spacing-16">
            <div className="container">
                <div className="tf-grid-layout md-col-2">
                    <div className="tf-ourstore-img">
                        <img className="lazyload" data-src="images/shop/store/ourstore2.png" src="images/shop/store/ourstore2.png" alt="our-store"/>
                    </div>
                    <div className="tf-ourstore-content">
                        <h5 className="mb_24">Ecomus Paris</h5>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Email</strong></p>
                            <p>support@royalhood.in</p>
                        </div>
                        <div className="mb_36">
                            <p className="mb_15"><strong>Open Time</strong></p>
                            <p className="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div className="mb_30">
                            <ul className="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" className="box-icon link round social-facebook border-line-black"><i className="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" className="box-icon link round social-twiter border-line-black"><i className="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" className="box-icon link round social-instagram border-line-black"><i className="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" className="box-icon link round social-tiktok border-line-black"><i className="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" className="box-icon link round social-pinterest border-line-black"><i className="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                            <a href="/contactus" className="tf-btn btn-outline-dark radius-3"><span>Get Directions</span><i className="icon icon-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="flat-spacing-10">
            <div className="container">
                <div className="tf-grid-layout md-col-2">
                    <div className="tf-ourstore-content pl-124">
                        <h5 className="mb_24">Ecomus London</h5>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Email</strong></p>
                            <p>support@royalhood.in</p>
                        </div>
                        <div className="mb_36">
                            <p className="mb_15"><strong>Open Time</strong></p>
                            <p className="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div className="mb_30">
                            <ul className="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" className="box-icon link round social-facebook border-line-black"><i className="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" className="box-icon link round social-twiter border-line-black"><i className="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" className="box-icon link round social-instagram border-line-black"><i className="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" className="box-icon link round social-tiktok border-line-black"><i className="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" className="box-icon link round social-pinterest border-line-black"><i className="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                            <a href="/contactus" className="tf-btn btn-outline-dark radius-3"><span>Get Directions</span><i className="icon icon-arrow-right"></i></a>
                        </div>
                    </div>
                    <div className="tf-ourstore-img">
                        <img className="lazyload" data-src="images/shop/store/ourstore4.png" src="images/shop/store/ourstore4.png" alt="our-store"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="flat-spacing-15">
            <div className="container">
                <div className="tf-grid-layout md-col-2">
                    <div className="tf-ourstore-img">
                        <img className="lazyload" data-src="images/shop/store/ourstore3.png" src="images/shop/store/ourstore3.png" alt="our-store"/>
                    </div>
                    <div className="tf-ourstore-content">
                        <h5 className="mb_24">Ecomus Dubai</h5>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div className="mb_20">
                            <p className="mb_15"><strong>Email</strong></p>
                            <p>support@royalhood.in</p>
                        </div>
                        <div className="mb_36">
                            <p className="mb_15"><strong>Open Time</strong></p>
                            <p className="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div className="mb_30">
                            <ul className="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" className="box-icon link round social-facebook border-line-black"><i className="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" className="box-icon link round social-twiter border-line-black"><i className="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" className="box-icon link round social-instagram border-line-black"><i className="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" className="box-icon link round social-tiktok border-line-black"><i className="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" className="box-icon link round social-pinterest border-line-black"><i className="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                            <a href="/contactus" className="tf-btn btn-outline-dark radius-3"><span>Get Directions</span><i className="icon icon-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
export default OurStore